import React from 'react';
import clsx from "clsx";
import ShowArticleCostsButtonRowProperties from './ShowArticleCostsButtonRowProperties';
import { useStyles } from '../ShowArticleCostsButton.style';
import ShowText from '../../../Info/ShowText/ShowText';
import Article from '../../../../entities/Article';
import ShowPrice from '../../../Info/ShowPrice/ShowPrice';
import ShowDeliveryTime from '../../../Info/ShowDeliveryTime/ShowDeliveryTime';
import Currency from '../../../../entities/Currency';
import ShowImage from '../../../Info/ShowImage/ShowImage';

const ShowArticleCostsButtonRowMedium: React.FC<ShowArticleCostsButtonRowProperties> = ({
    articleId,
    prices,
    articles
}) => {
    const classes = useStyles();
    const article = articles.find((t: Article) => t.id === articleId);

    return (
        <div className={clsx(classes.show_article_price_info_container)}>
            <div className={classes.article_name}>
                <ShowImage imageName={article?.defaultImage} width={60} height={60}/>
                <ShowText text={article?.name ?? ''} className={classes.article_name_container}/>
            </div>
            <div className={classes.price_and_delivery_item_container}>
                {prices.map((price, index) => (
                    <div 
                        key={index} 
                        className={classes.price_and_delivery_item}
                    >
                        <div className={classes.currencies_values_container}>
                            <div className={classes.price_and_button_container}>
                                <ShowPrice 
                                    value={price.salePrice} 
                                    currency={Currency.DOLLAR}
                                />
                            </div>
                            <ShowDeliveryTime 
                                deliveryTime={price.deliveryTimeDays}
                            />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default ShowArticleCostsButtonRowMedium;
